export const deleteUserErrCodes = {
  ERROR_PERMISSION_DENIED: 'permission_denied',
  ERROR_ALREADY_DONE_ACTIVITIES_IN_THE_SYSTEM:
    'already_done_activities_in_the_system',
};
